import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../Util/Toast/toast.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-company-frame',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent],
  templateUrl: './company-frame.component.html',
  styleUrl: './company-frame.component.scss'
})
export class CompanyFrameComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  safeUrl: SafeResourceUrl | undefined;
  constructor(private activemodal: NgbActiveModal,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sanitizer: DomSanitizer
  ) {
     this.common.getPageRights();
  }

  ngOnInit() {
    //console.log(this.InputData.DocumentAttachmentLink);
    //this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.InputData.DocumentAttachmentLink);
    let documentLink = this.InputData.DocumentAttachmentLink;
    documentLink += '#toolbar=0';
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(documentLink);
  }

  Close() {
    this.activemodal.close()
  }
}
